const BASE_URL = 'https://community-app-notification-server.onrender.com';

const APP_NAMES = {
    development: 'jiremalisamajdev',
    production: 'jiremalisamaj',
    thecodershub: 'thecodershub',
};

class NotificationService {
    static getAppName(environment) {
        return APP_NAMES[environment] || APP_NAMES.development;
    }

    static getCurrentEnvironment() {
        return process.env.REACT_APP_ENV || 'development';
    }

    static getBaseUrl() {
        const env = this.getCurrentEnvironment();
        const appName = this.getAppName(env);
        return `${BASE_URL}/${appName}`;
    }

    /**
     * Send topic notification
     * @param {Object} params
     * @param {string} params.topic - FCM topic name
     * @param {string} params.title - Notification title
     * @param {string} params.body - Notification body
     * @param {string} params.category - Category (article, job, etc.)
     * @param {Object} [params.data] - Additional data payload
     */
    static async sendToTopic({ topic, title, body, category, data = {} }) {
        const url = `${this.getBaseUrl()}/sendToTopic`;
        return this._send(url, { topic, title, body, category, data });
    }

    /**
     * Send one-to-one notification
     * @param {Object} params
     * @param {string[]} params.fcmTokens - Device FCM tokens
     * @param {string} params.title - Notification title
     * @param {string} params.body - Notification body
     * @param {string} params.category - Category (article, job, chat, etc.)
     * @param {Object} [params.data] - Additional data payload
     */
    static async send({ fcmTokens, title, body, category, data = {} }) {
        const url = `${this.getBaseUrl()}/send`;
        return this._send(url, { fcmTokens, title, body, category, data });
    }

    static async _send(url, payload) {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            console.warn('Notification request failed:', response.status);
        }
        return response;
    }
}

export default NotificationService;
